import { render } from "./ModalConsent.vue?vue&type=template&id=31ca37b8"
import script from "./ModalConsent.vue?vue&type=script&lang=js"
export * from "./ModalConsent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__